"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const framer_motion_1 = require("framer-motion");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const modal_module_css_1 = __importDefault(require("./modal.module.css"));
const Modal = ({ children, onClose, isOpen, className, buttonClass, isCloseButton = true }) => {
    const TgObj = sdk_1.default;
    const modalRef = (0, react_1.useRef)(null);
    const [isClosing, setIsClosing] = (0, react_1.useState)(false);
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        setIsClosing(true);
    };
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target) && isClosing) {
                handleCloseModal();
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose, isClosing]);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    }, [isOpen]);
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { onExitComplete: onClose, children: isOpen && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: modal_module_css_1.default.modalBackdrop, transition: {
                duration: 0.3,
                bounce: 0
            }, children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: `${modal_module_css_1.default.modalContent} ${className || ''}`, ref: modalRef, initial: { y: '100%' }, animate: { y: 0 }, exit: { y: '100%' }, transition: {
                    duration: 0.3,
                    bounce: 0,
                    type: 'spring'
                }, children: [isCloseButton && ((0, jsx_runtime_1.jsx)("button", { className: `${modal_module_css_1.default.closeButton} ${buttonClass || ''}`, onClick: handleCloseModal, children: "\u00D7" })), children] }) })) }));
};
exports.Modal = Modal;
